import React, { ReactNode } from "react";

export interface HeadingProps {
	children?: ReactNode;
}

const Heading: React.FC<HeadingProps> = (props) => {
	const { children } = props;

	return (
		<React.Fragment>
			<h1 className="heading text-left m-bottom bold">{children}</h1>
		</React.Fragment>
	);
};

export default Heading;
